import dayjs from 'dayjs'
import { dateFormat } from '@app/constants'

import type { ObjectValuesType } from '@app/types'

export const isValidDate = (date: string, format: ObjectValuesType<typeof dateFormat>): boolean =>
  dayjs(date, format, true).isValid()
